// @i18n-ignore-file
import { ExperimentDefinition } from '../experiments.types'

const EXPERIMENTS = {
  PDP_PARTNER_REC: {
    experimentName: 'pdp-partner-rec',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  PREORDER: {
    experimentName: 'preorder',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  MINI_PDP: {
    experimentName: 'mini-pdp',
    bucketNames: {
      control: 'control',
      testA: 'testA',
      testB: 'testB',
    },
  },
  PDP_COMPARISION_SECTION: {
    experimentName: 'pdp-comparison-section',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  REVIEW_HIGHLIGHTS_MOBILE: {
    experimentName: 'review-highlights-mobile',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
} satisfies Record<string, ExperimentDefinition>

export default EXPERIMENTS
